import hideout from './hideout.png'
import favorite from './favorite.png'

export default [hideout, favorite]
